'use client';

import { Box } from '@mui/material';
import Image from 'next/image';
import CompanyImage from '../../../../public/images/company.png';
import AssociationImage from '../../../../public/images/nonprofit_association.png';
import AdministrationImage from '../../../../public/images/public_institution.png';
import { useBreakpoint, useTheme } from '../../../hooks';
import { BodyLarge, HeadlineMedium, HeadlineSmall } from '../../../styles';
import { getBreakpointValue, isExpanded } from '../../../types';
import { LandingPageHeadline } from './components/LandingPageHeadline';
import { LandingPageCardContainer, LandingPageRoleCard, LandingPageSection } from './styles';
import { useTranslations } from 'next-intl';

enum TargetGroup {
    Administration,
    Association,
    Company
}

const LandingPageTargetGroupSection = () => {
    const t = useTranslations('landing_page');
    const breakpoint = useBreakpoint();
    const { colors } = useTheme();

    const getCardImageSrc = (group: TargetGroup) => {
        switch (group) {
            case TargetGroup.Administration:
                return AdministrationImage;
            case TargetGroup.Association:
                return AssociationImage;
            case TargetGroup.Company:
                return CompanyImage;
            default:
                return CompanyImage;
        }
    };

    const renderRoleCard = (group: TargetGroup) => {
        const cardNumber = (group as number) + 1;
        return (
            <LandingPageRoleCard>
                <Image
                    src={getCardImageSrc(group)}
                    alt={`Image of${t(`group.${cardNumber}.title` as 'group.1.title' | 'group.2.title' | 'group.3.title')}`}
                    style={{ width: '100%', height: 'auto' }}
                />
                <Box mt={3}>
                    {getBreakpointValue(
                        breakpoint,
                        <HeadlineSmall color={colors.onPrimaryDark}>
                            {t(
                                `group.${cardNumber}.title` as
                                    | 'group.1.title'
                                    | 'group.2.title'
                                    | 'group.3.title'
                            )}
                        </HeadlineSmall>,
                        <HeadlineMedium color={colors.onPrimaryDark}>
                            {t(
                                `group.${cardNumber}.title` as
                                    | 'group.1.title'
                                    | 'group.2.title'
                                    | 'group.3.title'
                            )}
                        </HeadlineMedium>,
                        <HeadlineMedium color={colors.onPrimaryDark}>
                            {t(
                                `group.${cardNumber}.title` as
                                    | 'group.1.title'
                                    | 'group.2.title'
                                    | 'group.3.title'
                            )}
                        </HeadlineMedium>
                    )}
                    <BodyLarge my={2}>
                        {t(
                            `group.${cardNumber}.text` as
                                | 'group.1.text'
                                | 'group.2.text'
                                | 'group.3.text'
                        )}
                    </BodyLarge>
                </Box>
            </LandingPageRoleCard>
        );
    };

    return (
        <LandingPageSection breakpoint={breakpoint} mb={5}>
            <LandingPageHeadline headline={t('targetgroups_title')} />
            <LandingPageCardContainer mt={7} isExpanded={isExpanded(breakpoint)}>
                {renderRoleCard(TargetGroup.Administration)}
                {renderRoleCard(TargetGroup.Association)}
                {renderRoleCard(TargetGroup.Company)}
            </LandingPageCardContainer>
        </LandingPageSection>
    );
};

export { LandingPageTargetGroupSection };
